import { Injectable } from '@angular/core';
import { Router } from '@angular/router';

@Injectable({ providedIn: 'root' })
export class ActivationService {
  constructor(private router: Router) {}

  public navigateToLogin() {
    this.router.navigateByUrl('/user/login');
  }
}
